import { dateFormatEn } from '@/configs/dateFormat';
import { useSetting } from '@/contexts/CompanyContext';
import { IOrder, IOrderItem } from '@/interfaces/order';
import { formatDate, formatNumber } from '@/utils/dataUtils';
import {
  generateQRCodePaymentValue,
  isValidateQRCode,
} from '@/utils/qrCodeUtils';
import { QRCode, Space } from 'antd';
import React from 'react';
import _ from 'lodash';

interface IProps {
  data: IOrder;
  isShowPrice?: boolean;
  isShowPackage?: boolean;
  isShowShiptoRemark?: boolean;
  customerCode?: string;
  ivNo?: string;
  amount?: number;
}

const TemplateOrderInfoItemExport = ({
  data,
  customerCode,
  ivNo,
  amount,
}: IProps) => {
  const { setting } = useSetting();
  const isValidate = isValidateQRCode(
    setting?.companyBillerId,
    setting?.referenceCode,
    customerCode,
    ivNo,
  );
  const qrCode = generateQRCodePaymentValue(
    setting?.companyBillerId,
    setting?.referenceCode,
    customerCode,
    ivNo,
    amount || 0,
  );

  console.log(qrCode);

  const groupedData: Partial<IOrderItem>[] = _(data?.orderItems || [])
    .groupBy(
      item =>
        `${item.productCode}|${item.unitPrice}|${item.isFoc}|${item.alterUnitPrice}`,
    )
    .map((items, key) => {
      const [productCode, unitPrice, isFoc, alterUnitPrice] = key.split('|');
      return {
        productCode,
        unitPrice: parseFloat(unitPrice),
        alterUnitPrice: parseFloat(alterUnitPrice),
        isFoc: isFoc === 'true',
        quantity: _.sumBy(items, 'quantity'),
        baseUnitName: items[0].baseUnitName,
        productName: items[0].productName,
        totalPrice: Number(parseFloat(unitPrice) * _.sumBy(items, 'quantity')),
        alterTotalPrice: Number(
          parseFloat(alterUnitPrice) * _.sumBy(items, 'quantity'),
        ),
      } as Partial<IOrderItem>;
    })
    .value();

  return (
    <>
      <div className="flex w-full text-xs mt-2">
        <table
          border={1}
          cellSpacing={0}
          cellPadding={5}
          style={{
            width: '100%',
            border: '0.5px; black solid',
            borderCollapse: 'collapse',
            // height: 360,
          }}
        >
          <tr style={{ height: 45 }}>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
            >
              <strong>DESCRIPTION</strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
              width={30}
            >
              <strong>UNIT</strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
              width={70}
            >
              <strong>QUANTITY</strong>
            </td>

            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
              width={70}
            >
              <strong>
                PRICE <br /> (THB)
              </strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
              width={90}
            >
              <strong>AMOUNT (THB)</strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
              width={70}
            >
              <strong>
                FX PRICE <br /> ({data?.currency})
              </strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
              width={100}
            >
              <strong>
                TOTAL AMOUNT <br /> ({data?.currency})
              </strong>
            </td>
          </tr>
          {groupedData?.map(i => {
            return (
              <tr key={i.id}>
                <td
                  style={{
                    borderLeft: '1px solid black',
                    textAlign: 'center',
                  }}
                >
                  {i.productName}
                </td>
                <td
                  style={{
                    textAlign: 'center',
                  }}
                >
                  {i.baseUnitName}
                </td>
                <td
                  style={{
                    textAlign: 'right',
                  }}
                >
                  {formatNumber(Number(i.quantity), 2)}
                </td>
                <td
                  style={{
                    textAlign: 'right',
                  }}
                >
                  {i.isFoc ? 'FOC' : formatNumber(Number(i.unitPrice), 2)}
                </td>
                <td
                  style={{
                    textAlign: 'right',
                  }}
                >
                  {formatNumber(Number(i.totalPrice), 2)}
                </td>
                <td
                  style={{
                    textAlign: 'right',
                  }}
                >
                  {i.isFoc ? 'FOC' : formatNumber(Number(i.alterUnitPrice), 2)}
                </td>
                <td
                  style={{
                    borderRight: '1px solid black',
                    textAlign: 'right',
                  }}
                >
                  {formatNumber(Number(i.alterTotalPrice), 2)}
                </td>
              </tr>
            );
          })}
          <tr>
            <td
              style={{
                borderTop: '1px solid black',
                borderLeft: '1px solid black',
                textAlign: 'right',
                verticalAlign: 'middle',
              }}
              colSpan={4}
            >
              <p className="font-lg font-bold">TOTAL</p>
            </td>
            <td
              style={{
                borderTop: '1px solid black',
                textAlign: 'right',
                verticalAlign: 'middle',
              }}
              colSpan={1}
            >
              <p className="font-lg font-bold">
                {formatNumber(data?.totalAmount || 0, 2)}
              </p>
            </td>
            <td
              style={{
                borderTop: '1px solid black',
                textAlign: 'right',
                verticalAlign: 'middle',
              }}
              colSpan={1}
            ></td>
            <td
              style={{
                borderTop: '1px solid black',
                borderRight: '1px solid black',
                textAlign: 'right',
                verticalAlign: 'middle',
              }}
              colSpan={1}
            >
              <p className="font-lg font-bold">
                {' '}
                {formatNumber(data?.totalAmountAlter || 0, 2)}
              </p>
            </td>
          </tr>
          {((data?.discountAmount || data?.discountAmountAlterFOC) && (
            <tr>
              <td
                style={{
                  textAlign: 'right',
                  verticalAlign: 'middle',
                  borderLeft: '1px solid black',
                }}
                colSpan={4}
              >
                <p className="font-lg font-bold">DISCOUNT</p>
              </td>
              <td
                style={{
                  textAlign: 'right',
                  verticalAlign: 'middle',
                }}
                colSpan={1}
              >
                <p className="font-lg font-bold">
                  {formatNumber(
                    (data?.discountAmount || 0) +
                      (data?.discountAmountFOC || 0),
                    2,
                  )}
                </p>
              </td>
              <td
                style={{
                  textAlign: 'right',
                  verticalAlign: 'middle',
                }}
                colSpan={1}
              ></td>
              <td
                style={{
                  textAlign: 'right',
                  verticalAlign: 'middle',
                  borderRight: '1px solid black',
                }}
                colSpan={1}
              >
                <p className="font-lg font-bold">
                  {formatNumber(
                    (data?.discountAmountAlter || 0) +
                      (data?.discountAmountAlterFOC || 0),
                    2,
                  )}
                </p>
              </td>
            </tr>
          )) ||
            undefined}
          <tr>
            <td
              style={{
                textAlign: 'right',
                verticalAlign: 'middle',
                borderLeft: '1px solid black',
              }}
              colSpan={4}
            >
              <p className="font-lg font-bold">TOTAL AFTER DISCOUNT</p>
            </td>
            <td
              style={{
                textAlign: 'right',
                verticalAlign: 'middle',
              }}
              colSpan={1}
            >
              <p className="font-lg font-bold">
                {formatNumber(data?.totalAfterDiscountAmount || 0, 2)}
              </p>
            </td>
            <td
              style={{
                textAlign: 'right',
                verticalAlign: 'middle',
              }}
              colSpan={1}
            ></td>
            <td
              style={{
                textAlign: 'right',
                verticalAlign: 'middle',
                borderRight: '1px solid black',
              }}
              colSpan={1}
            >
              <p className="font-lg font-bold">
                {formatNumber(data?.totalAfterDiscountAmountAlter || 0, 2)}
              </p>
            </td>
          </tr>
          {(data?.vatRate && (
            <tr>
              <td
                style={{
                  textAlign: 'right',
                  verticalAlign: 'middle',
                  borderLeft: '1px solid black',
                }}
                colSpan={4}
              >
                <p className="font-lg font-bold">VAT {data?.vatRate} %</p>
              </td>
              <td
                style={{
                  textAlign: 'right',
                  verticalAlign: 'middle',
                }}
                colSpan={1}
              >
                <p className="font-lg font-bold">
                  {formatNumber(data?.vatAmount || 0, 2)}
                </p>
              </td>
              <td
                style={{
                  textAlign: 'right',
                  verticalAlign: 'middle',
                }}
                colSpan={1}
              ></td>
              <td
                style={{
                  textAlign: 'right',
                  verticalAlign: 'middle',
                  borderRight: '1px solid black',
                }}
                colSpan={1}
              >
                <p className="font-lg font-bold">
                  {formatNumber(data?.vatAmountAlter || 0, 2)}
                </p>
              </td>
            </tr>
          )) ||
            undefined}
          <tr>
            <td
              style={{
                textAlign: 'right',
                verticalAlign: 'middle',
                borderLeft: '1px solid black',
                borderBottom: '1px solid black',
              }}
              colSpan={4}
            >
              <p className="font-lg font-bold">SUMMARY</p>
            </td>
            <td
              style={{
                textAlign: 'right',
                verticalAlign: 'middle',
                borderBottom: '1px solid black',
              }}
              colSpan={1}
            >
              <p className="font-lg font-bold">
                {formatNumber(data?.summary || 0, 2)}
              </p>
            </td>
            <td
              style={{
                textAlign: 'right',
                verticalAlign: 'middle',
                borderBottom: '1px solid black',
              }}
              colSpan={1}
            ></td>
            <td
              style={{
                textAlign: 'right',
                verticalAlign: 'middle',
                borderRight: '1px solid black',
                borderBottom: '1px solid black',
              }}
              colSpan={1}
            >
              <p className="font-lg font-bold">
                {formatNumber(data?.summaryAlter || 0, 2)}
              </p>
            </td>
          </tr>
        </table>
      </div>
      <div className="flex w-full text-xs mt-2">
        <table
          border={1}
          cellSpacing={0}
          cellPadding={5}
          style={{
            width: '100%',
            border: '0.5px; black solid',
            borderCollapse: 'collapse',
          }}
        >
          <tr>
            <td colSpan={2} style={{ border: '1px solid black' }}>
              <p className="font-bold pb-2 uppercase">
                {data?.exportType || '-'}
              </p>
              <p className="mt-1">
                <span className="font-bold mt-1">Country of Origin: </span>
                {data?.countryOfOrgin || '-'}
              </p>
              <p className="mt-1">
                <span className="font-bold mt-1"> Incoterm: </span>
                {data?.incoTerm || '-'}
              </p>
              <p className="mt-1">
                <span className="font-bold mt-1"> Method of Transport: </span>
                By {data?.transportation}
              </p>
              <p className="mt-1">
                <span className="font-bold "> ETA: </span>
                {data?.eta && formatDate(data?.eta, dateFormatEn, 'en')}
              </p>
              <p className="pb-2 mt-1">
                <span className="font-bold pb-2"> Payment Term: </span>
                {data?.paymentTerm || '-'}
              </p>
            </td>
          </tr>
          <tr>
            <td colSpan={1} style={{ border: '1px solid black' }}>
              <p className="font-bold text-right">COMMERCIAL TOTAL VALUE</p>
            </td>
            <td colSpan={1} style={{ border: '1px solid black' }} width={200}>
              <p className="font-bold text-center">
                {data?.summaryAlter && formatNumber(data?.summaryAlter, 2)}
              </p>
            </td>
          </tr>
          <tr>
            <td colSpan={1}>
              <p className="font-bold pb-2 mt-5">Bank Details: </p>
              <p className="uppercase pb-2">{setting?.companyNameEn}</p>
              <p className="mt-1">
                <span className="font-bold">Bank name: </span>
                {`${setting?.bankName}`}
              </p>
              <p className="mt-1">
                <span className="font-bold">Address: </span>
                {`${setting?.bankAddress}`}
              </p>
              <p className="mt-1">
                <span className="font-bold">Branch: </span>
                {`${setting?.branchName}`}
              </p>
              <p className="mt-1">
                <span className="font-bold">Saving Account Name: </span>
                {`${setting?.referenceCode}`}
              </p>
              <p className="mt-1">
                <span className="font-bold">SWIF CODE: </span>
                {`${setting?.swifCode}`}
              </p>
              <p className="mt-1">
                <span className="font-bold">Bank code: </span>
                {`${setting?.branchCodeExport}`}
              </p>
              <p className="mt-1">
                <span className="font-bold">Branch code: </span>
                {`${setting?.branchCode}`}
              </p>
            </td>
            <td
              style={{
                textAlign: 'center',
                verticalAlign: 'bottom',
              }}
              colSpan={1}
            >
              {isValidate && (
                <div className="flex flex-col gap-2 justify-center w-full">
                  <strong>QR Payment</strong>
                  <div className="w-full flex justify-center">
                    <Space direction="vertical" align="end">
                      <QRCode
                        value={qrCode}
                        // bordered={false}
                        size={90}
                        style={{ textAlign: 'center' }}
                      />
                    </Space>
                  </div>
                </div>
              )}
            </td>
          </tr>
        </table>
      </div>
    </>
  );
};

export default TemplateOrderInfoItemExport;
